<template>
    <footer class="lg:px-20 rounded-lg shadow dark:bg-gray-900 bg-gray-50/50 z-50">
        <div class="w-full p-4 md:py-8">
            <div class="sm:flex sm:items-center sm:justify-between">
                <a
                    href="/"
                    class="flex items-center mb-4 sm:mb-0"
                >
                    <strong>Open CDL Jobs</strong>
                </a>
                <ul
                    class="flex flex-wrap items-center space-x-4 mb-6 text-sm font-light text-gray-500 sm:mb-0 dark:text-gray-400"
                >
                    <li>
                        <Link
                            :href="route('about')"
                            :class="{
                                'border-b-4 border-blue-500 pb-3 text-blue-500':
                                    $page.component === 'About',
                            }"
                            class="text-md tracking-wider hover:text-gray-300 transition"
                            >About</Link
                        >
                    </li>
                    <li>
                        <Link
                            :href="route('contact')"
                            :class="{
                                'border-b-4 border-blue-500 pb-3 text-blue-500':
                                    $page.component === 'Contact',
                            }"
                            class="text-md tracking-wider hover:text-gray-300 transition"
                            >Contact</Link
                        >
                    </li>
                    <li>
                        <Link
                            :href="route('privacy-policy')"
                            :class="{
                                'border-b-4 border-blue-500 pb-3 text-blue-500':
                                    $page.component === 'PrivacyPolicy',
                            }"
                            class="text-md tracking-wider hover:text-gray-300 transition"
                            >Privacy Policy</Link
                        >
                    </li>
                </ul>
            </div>
            <hr
                class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8"
            />
            <span
                class="block text-sm text-gray-500 sm:text-center dark:text-gray-400"
                >© {{ year }}
                <a href="/" class="hover:underline"
                    >Open CDL Jobs</a
                >. All Rights Reserved.</span
            >
        </div>
    </footer>
</template>

<script setup>
import { Link, usePage } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { computed } from "vue";

defineProps({
    auth: Object,
});

const page = usePage();

const route = window.route;
const year = computed(() => new Date().getFullYear());
const onLoginPage = computed(() => page.component.value === "Auth/Login");

function logout() {
    Inertia.post(route("logout"));
}
</script>
